export interface Colour {
  id: string;
  key: string;
  description: string;
}
